import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'rd-flipping-card',
  template: `<div class="cardContainer" [style.height.px]="height">
  <div class="flipCard" [class.flipped]="isFlip" [class.bounce]="bounce" [class.rounded]="rounded"
  (click)="flipCard()">
    <div class="front">
      <ng-content select="[front]"></ng-content>
    </div>
    <div class="back">
      <ng-content class="back" select="[back]"></ng-content>
    </div>
  </div>
</div>
`,
  styles: [`.cardContainer{width:100%}.flipCard{position:relative;width:100%;height:100%;cursor:pointer;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transform-origin:center center;transform-origin:center center;transition-duration:.8s;transition-property:-webkit-transform;transition-property:transform;transition-property:transform,-webkit-transform}.flipCard.flipped{-webkit-transform:rotateY(-180deg);transform:rotateY(-180deg)}.flipCard.bounce{transition-timing-function:cubic-bezier(.1,.6,.4,1.25)}.flipCard.rounded>div{border-radius:12px}.flipCard .back,.flipCard .front{position:absolute;left:0;width:100%;height:100%;overflow-y:auto;color:#fff;-webkit-backface-visibility:hidden;backface-visibility:hidden;box-shadow:0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12);overflow:hidden}.flipCard .front{background:#ba5a5a}.flipCard .back{background:#5a5aba;-webkit-transform:rotateY(180deg);transform:rotateY(180deg)}.flipCard .cardContent{height:100%}`]
})
export class RDFlippingCardComponent implements OnInit {

  @Input() rounded = false;
  @Input() bounce = false;
  @Input() height = 200;

  @Output() cardFlipped: EventEmitter<any> = new EventEmitter();

  public isFlip = false;

  constructor() { }

  ngOnInit() {
  }

  flipCard() {
    this.isFlip = !this.isFlip;
    this.cardFlipped.emit(this.isFlip);
  }

}
